import { createRateioAdapter } from './adapters/Rateio';
import {
  BillingModeEnum,
  IBillingSplitResponse,
  IRateioResponse,
  IRateioUpdateRequest,
} from './interfaces/Faturamento/IRateio';
import { ISpeRequest, ISpeResponse } from './interfaces/Faturamento/ISpe';

// Camada de dados do rateio de faturamento, consumida por hooks e sagas.
//
// Diferença deliberada em relação às outras classes de Data/: os métodos aqui
// retornam o payload de domínio, não AxiosResponse<T>. Passar AxiosResponse
// adiante vazaria o transporte para dentro do mock e derrubaria a troca de
// adaptador que este épico exige. Todo o resto do padrão é mantido: classe com
// métodos estáticos, um por operação, tipagem explícita.

export class RateioApi {
  // `tenantId` só é informado pelo painel /adm; ver IRateioAdapter.
  static async getBillingSplit(tenantId?: number): Promise<IBillingSplitResponse> {
    return createRateioAdapter().getBillingSplit(tenantId);
  }

  static async setBillingMode(
    mode: BillingModeEnum,
    tenantId?: number
  ): Promise<IBillingSplitResponse> {
    return createRateioAdapter().setBillingMode(mode, tenantId);
  }

  static async addSpe(spe: ISpeRequest, tenantId?: number): Promise<ISpeResponse> {
    return createRateioAdapter().addSpe(spe, tenantId);
  }

  static async updateSpe(
    speId: string,
    spe: ISpeRequest,
    tenantId?: number
  ): Promise<ISpeResponse> {
    return createRateioAdapter().updateSpe(speId, spe, tenantId);
  }

  static async removeSpe(speId: string, tenantId?: number): Promise<IBillingSplitResponse> {
    return createRateioAdapter().removeSpe(speId, tenantId);
  }

  static async updateRateio(
    request: IRateioUpdateRequest,
    tenantId?: number
  ): Promise<IRateioResponse> {
    return createRateioAdapter().updateRateio(request, tenantId);
  }

  static async resendTermsAcceptance(speId?: string, tenantId?: number): Promise<void> {
    return createRateioAdapter().resendTermsAcceptance(speId, tenantId);
  }
}
